import { IIconProps } from "../types"

export default function IconUR7(props: IIconProps) {
  const width = props.size || props.width || (93 / 5) * 3
  const height = props.size || props.height || (95 / 5) * 3
  const fill = props.fill || "white"
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 93 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.1196 0.849213C39.188 0.389361 45.276 0.299389 51.2041 0.719255C57.1322 1.14912 62.9004 2.07882 67.0291 3.29843C71.1677 4.52803 73.6669 6.05754 76.0362 8.80666C78.4154 11.5558 80.6547 15.5345 83.0939 21.3226C85.5231 27.1208 88.1523 34.7383 89.7218 40.0267C91.2913 45.315 91.8111 48.274 92.0311 52.7226C92.261 57.1612 92.191 63.0793 91.5512 67.8677C90.9114 72.6462 89.6918 76.285 88.3122 79.7939C86.9327 83.3128 85.3932 86.6917 83.6038 89.0609C81.8043 91.4302 79.755 92.7897 77.4857 93.4195C75.2064 94.0593 72.7072 93.9694 69.5683 93.4195C66.4293 92.8697 62.6405 91.85 57.6721 90.8004C52.7037 89.7407 46.5556 88.6411 42.0071 88.6811C37.4485 88.721 34.4995 89.9107 32.0403 90.9203C29.5711 91.94 27.5817 92.7897 25.1425 92.6998C22.7133 92.6098 19.8242 91.6001 17.0051 89.8207C14.186 88.0413 11.4269 85.5121 8.79773 81.4434C6.16858 77.3847 3.66938 71.7965 2.12987 66.3882C0.590364 60.9699 0.0205465 55.7216 0.7903 49.6336C1.56005 43.5355 3.66938 36.5978 5.97864 29.8699C8.2879 23.1421 10.7871 16.6342 13.3163 12.1856C15.8555 7.747 18.4146 5.37776 21.7136 3.76828C25.0125 2.15879 29.0512 1.31906 34.1196 0.849213Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
